import React from 'react';
import {Box} from '@mui/material'; // Assuming you're using Material-UI, but you can adapt as needed
import './ModernOneToolsSection.css';
import CardMedia from "@mui/material/CardMedia";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import {VideoPlayer} from "../../../components/VideoPlayer"; // External CSS file

const ModernOneToolSection = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isSmallerScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const width = isSmallScreen ? "80vw" : "30vw";
    const height = isSmallScreen ? "250px" : isSmallerScreen ? "350px" : "430px";

    return (
        <Box
            sx={{
                overflowX: "auto",
                overflowY: "hidden",
                whiteSpace: "nowrap",
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE 10+
                "&::-webkit-scrollbar": {
                    display: "none", // Chrome, Safari, Opera
                },
                display: "flex",
                gap: "30px",
                width: "100%",
                paddingX: "20px",
            }}
        >
            {[
                {
                    title: "Podcasts",
                    image:
                        "https://image.mux.com/VbaPNbrlslYJc82thIFDZagQjV00HeZB01kDplNUOmTMQ/thumbnail.png?width=450&height=450&time=2",
                    text: "Invite and record with guests. No download required.",
                },
                {
                    title: "Voiceovers",
                    image:
                        "https://storage.googleapis.com/libretto-public-assets/images/Voiceover.jpeg",
                    text: "Capture your mic, and add sound effects & music.",
                },
                {
                    title: "Video Recording",
                    image:
                        "https://image.mux.com/P02vbyVPKoKNbYvnmoY3XQQ6Jx5AKvjz00Hl6bfdRaLvQ/thumbnail.png?width=450&height=450&time=6",
                    text: "Perfect for tutorials, product demos, or webinars.",
                },
            ].map(({title, image, text}, i) => (
                <Box
                    key={i}
                    className="box-item"
                    sx={{
                        width,
                        display: "inline-block", // change from "inline-flex"
                        verticalAlign: "top",
                        padding: "35px",
                        scrollSnapAlign: "start",
                        backgroundColor: "#fff",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.05)",
                    }}
                >
                    <Box
                        component={CardMedia}
                        height={height}
                        image={image}
                        sx={{borderRadius: "12px"}}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            marginTop: "20px",
                            whiteSpace: "normal", // 🟢 allow text to wrap
                        }}
                    >
                        <Box sx={{fontWeight: 600, fontSize: "22px", color: "text.primary"}}>
                            {title}
                        </Box>
                        <Box
                            sx={{
                                fontWeight: 400,
                                fontSize: "16px",
                                color: "#555555",
                                marginTop: "12px",
                                lineHeight: 1.5,
                            }}
                        >
                            {text}
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export const ModernReliableRecordingSection = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallerScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const width = isSmallScreen ? '100%' : '30vw';
    const height = isSmallScreen ? '250px' : isSmallerScreen ? '350px' : '430px';

    const items = [
        {
            title: 'Podcasts',
            image: 'https://image.mux.com/VbaPNbrlslYJc82thIFDZagQjV00HeZB01kDplNUOmTMQ/thumbnail.png?width=450&height=450&time=2',
            text: 'Invite and record with guests. No download required.',
        },
        {
            title: 'Voiceovers',
            image: 'https://storage.googleapis.com/libretto-public-assets/images/Voiceover.jpeg',
            text: 'Record mic, with added music and sound effects.',
        },
        {
            title: 'Video Recording',
            image: 'https://image.mux.com/P02vbyVPKoKNbYvnmoY3XQQ6Jx5AKvjz00Hl6bfdRaLvQ/thumbnail.png?width=450&height=450&time=6',
            text: 'Perfect for tutorials, product demos, or webinars.',
        },
    ];

    return (
        <Box
            sx={{
                overflowX: 'auto',
                overflowY: 'hidden',
                whiteSpace: 'nowrap',
                scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
                display: 'flex',
                gap: '30px',
                paddingX: '20px',
                scrollBehavior: 'smooth',
            }}
        >
            {items.map(({title, image, text}, i) => (
                <Box
                    key={i}
                    className="box-item"
                    sx={{
                        width: isSmallScreen ? '100%' : '30vw',
                        flex: '0 0 auto',
                        display: 'inline-block',
                        scrollSnapAlign: 'start',
                        padding: '35px',
                        borderRadius: '12px',
                        backgroundColor: '#fff',
                        boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
                    }}
                >
                    <Box
                        component={CardMedia}
                        image={image}
                        height={height}
                        sx={{borderRadius: '12px', width: '100%'}}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            marginTop: '20px',
                            whiteSpace: 'normal',
                        }}
                    >
                        <Box sx={{fontWeight: 600, fontSize: '22px', color: 'text.primary'}}>{title}</Box>
                        <Box sx={{
                            fontWeight: 500,
                            fontSize: '18px',
                            color: '#555555',
                            marginTop: '8px',
                            lineHeight: 1.5
                        }}>
                            {text}
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};


export const ModernEffortlessEditingSection = () => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallerScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const width = isSmallScreen ? '100%' : '30%';
    const height = isSmallScreen ? '250px' : isSmallerScreen ? '350px' : '430px';

    return (
        <Box
            sx={{
                overflowX: 'auto',
                overflowY: 'hidden',
                whiteSpace: 'nowrap',
                scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
                display: 'flex',
                gap: '30px',
                paddingX: '20px',
                scrollBehavior: 'smooth',
            }}
        >
            {[
                {
                    title: 'Transcript Editing',
                    image: 'https://storage.googleapis.com/libretto-public-assets/images/Fillerwords.png',
                    text: 'Edit your recording like you’re editing a doc.',
                },
                {
                    title: 'Timeline Control',
                    image: 'https://image.mux.com/gxbmStTAIA8tZtCGngWMfCj6XbxyU00XJTeCURrBWu4Y/thumbnail.png?width=650&height=650&time=0',
                    text: 'Edit with full control using the timeline.',
                },
                {
                    title: 'Studio Sound',
                    video: 'https://stream.mux.com/ysf02H00YYG7NshadK8vpZuRWJkL5Bbyxh17cGqMjl1xQ.m3u8',
                    poster: 'https://image.mux.com/ysf02H00YYG7NshadK8vpZuRWJkL5Bbyxh17cGqMjl1xQ/thumbnail.png?width=214&height=121&time=3',
                    text: 'Clean up your audio with one click.',
                },
                // {
                //     title: 'Create Shorts',
                //     image: 'https://storage.googleapis.com/libretto-public-assets/images/Shorts.png',
                //     text: 'Highlight moments and scenes instantly.',
                // },
                // {
                //     title: 'Add Captions',
                //     image: 'https://storage.googleapis.com/libretto-public-assets/images/Captions.png',
                //     text: 'Get more views and make more accessible video, with less time and effort.',
                // },
                // {
                //     title: 'Share with one click',
                //     image: 'https://storage.googleapis.com/libretto-public-assets/images/ShareLink.png',
                //     text: 'Share recordings and edits via a link. No accounts or apps needed.',
                // },
            ].map(({title, image, text, video, poster}, i) => (
                <Box
                    key={i}
                    className="box-item"
                    sx={{
                        width: isSmallScreen ? '100%' : '30vw',
                        flex: '0 0 auto',
                        display: 'inline-block',
                        scrollSnapAlign: 'start',
                        padding: '35px',
                        borderRadius: '12px',
                        backgroundColor: '#fff',
                        boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
                    }}
                >
                    {video ? (
                        <VideoPlayer
                            src={video}
                            poster={poster}
                            width="auto"
                            height={height}
                            controls={false}
                            muted
                            cover
                        />
                    ) : (
                        <Box
                            component={CardMedia}
                            image={image}
                            height={height}
                            sx={{borderRadius: '12px', width: '100%'}}
                        />
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            marginTop: '20px',
                            whiteSpace: 'normal',
                        }}
                    >
                        <Box sx={{fontWeight: 600, fontSize: '22px', color: 'text.primary'}}>{title}</Box>
                        <Box sx={{
                            fontWeight: 500,
                            fontSize: '18px',
                            color: '#555555',
                            marginTop: '8px',
                            lineHeight: 1.5
                        }}>
                            {text}
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export const ModernShareAndRepurposeSection = () => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallerScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const width = isSmallScreen ? "100%" : "30%";
    const height = isSmallScreen ? "250px" : isSmallerScreen ? "350px" : "430px";
    const direction = isSmallScreen ? "column" : "row";

    return (
        <Box display="flex" justifyContent="space-around" width="100%" flexDirection={direction} gap={"30px"}>
            <Box className="box-item" width={width} display="flex" flexDirection="column" padding="35px">
                <Box
                    component={CardMedia}
                    height={height}
                    image="https://storage.googleapis.com/libretto-public-assets/images/Shorts.png"
                />
                <Box flexDirection="column" alignItems="flex-start" marginTop="20px" display="flex">
                    <Box sx={{fontWeight: 600, fontSize: "22px", color: "text.primary"}}>
                        Create Shorts
                    </Box>
                    <Box sx={{fontWeight: 500, fontSize: "18px", color: "text.secondary", marginTop: "8px"}}>
                        Highlight moments, instantly.
                    </Box>
                    <Box sx={{fontWeight: 400, fontSize: "16px", color: "#555555", marginTop: "12px", lineHeight: 1.5}}>
                        Select transcript highlights or key scenes to create short, social-ready clips. Or let Libretto
                        do
                        it for you automatically.
                    </Box>
                </Box>
            </Box>

            <Box className="box-item" width={width} display="flex" flexDirection="column" padding="35px">
                <Box
                    component={CardMedia}
                    height={height}
                    image="https://storage.googleapis.com/libretto-public-assets/images/Captions.png"
                />
                <Box flexDirection="column" alignItems="flex-start" marginTop="20px" display="flex">
                    <Box sx={{fontWeight: 600, fontSize: "22px", color: "text.primary"}}>
                        Add Captions
                    </Box>
                    <Box sx={{fontWeight: 500, fontSize: "18px", color: "text.secondary", marginTop: "8px"}}>
                        Add captions with one click.
                    </Box>
                    <Box sx={{fontWeight: 400, fontSize: "16px", color: "#555555", marginTop: "12px", lineHeight: 1.5}}>
                        Get more views and make more accessible video, with less time and effort.
                    </Box>
                </Box>
            </Box>

            <Box className="box-item" width={width} display="flex" flexDirection="column" padding="35px">
                <Box
                    component={CardMedia}
                    height={height}
                    image="https://storage.googleapis.com/libretto-public-assets/images/ShareLink.png"
                />
                <Box flexDirection="column" alignItems="flex-start" marginTop="20px" display="flex">
                    <Box sx={{fontWeight: 600, fontSize: "22px", color: "text.primary"}}>
                        Share with one click
                    </Box>
                    <Box sx={{fontWeight: 500, fontSize: "18px", color: "text.secondary", marginTop: "8px"}}>
                        Deliver your work instantly.
                    </Box>
                    <Box sx={{fontWeight: 400, fontSize: "16px", color: "#555555", marginTop: "12px", lineHeight: 1.5}}>
                        Share recordings and edits via a link. Recipients can stream and download directly, no accounts
                        or apps needed.
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default ModernOneToolSection;
